export default {"src":"https://fishbrain.com/_next/static/media/star.07a3ed1c.svg","height":31,"width":32,"blurWidth":0,"blurHeight":0};